<template>
    <div id="rootElement">
        <nav class="navbar">
            <span v-if="!impressumHeader" v-on:click="toggleNav" class="navbar-toggle" id="js-navbar-toggle">
                <img src="../../assets/images/menu.svg">
            </span>
            <div>
                <router-link class="logo" :to="isCustomerView||impressumHeader?'':'/campaigns'"><img
                    src="../../assets/images/adalliance.png"></router-link>
                <router-link :to="isCustomerView||impressumHeader?'':'/campaigns'" class="toolNameWrapper">
                    <span class="toolName">Engagement Tool &copy;</span>
                </router-link>

            </div>

            <ul v-if="!impressumHeader" class="main-nav" id="js-menu" ref="mainNav">
                <li v-if="!dashboardHeader" class="nav-li-item center">
                    <AdaButton v-if="route === 'showCampaign' ||  route === 'campaigns'" icon="icon-add"
                               type="createButton" title="Neue Kampagne" to="/campaigns/create"></AdaButton>
                    <AdaButton v-if="route === 'createCampaign'" @click="saveCampaign" title="Kampagne erstellen"
                               type="createButton" :loading="saveCampaignLoader"></AdaButton>
                    <AdaButton v-if="route === 'editCampaign'" @click="updateCampaign" type="createButton"
                               title="Änderungen speichern" icon="icon-save"
                               :loading="saveCampaignLoader"></AdaButton>
                    <AdaButton v-if="templateHeader" :to="createTemplate" type="createButton" title="NEUE VORLAGE"
                               icon="icon-add"></AdaButton>
                    <AdaButton v-if="route === 'templateinteractions'" @click="createInteraction"
                               type="createButton" title="NEUE VORLAGE"
                               icon="icon-add"></AdaButton>
                    <AdaButton v-if="trackinglistHeader" @click="saveTrackinglist" type="createButton"
                               title="Liste Speichern" :loading="saveTrackinglistLoader"></AdaButton>
                    <AdaButton v-if="spaceHeader" @click="saveSpaceTemplate" type="createButton"
                               title="Space Speichern" :loading="saveTrackinglistLoader"></AdaButton>
                    <AdaButton v-if="moduleHeader" @click="saveModuleTemplate" type="createButton"
                               title="Modul Speichern" :loading="saveTrackinglistLoader"></AdaButton>
                </li>

                <li v-if="dashboardHeader" class="nav-li-item center">
                    <span><AdaButton type="createButton" title="EXCEL EXPORT" icon="icon-download"
                                     :disabled="$store.state.trackingList.reporting_loading"
                                     @click="exportTrackingList" :loading="excelLoader"></AdaButton></span></li>
                <li v-if="dashboardHeader && isDashboardEditable" class="nav-li-item center">
                    <span><AdaButton v-if="isDashboardEditable" @click="openShareDialog" style="margin-left: 20px"
                                     :custom-styles="{backgroundColor: '#394956', borderColor: '#394956'}"
                                     type="createButton" title="Teilen" icon="icon-share"></AdaButton></span></li>
                <li v-if="dashboardHeader && isDashboardEditable" class="nav-li-item center">
                    <span v-if="isDashboardEditable"><AdaButton class="marginLeft" icon="icon-save"
                                                                type="createButton" @click="saveDashboard"
                                                                title="Speichern"
                                                                :loading="savingDashboard"></AdaButton></span>

                </li>

                <router-link v-if="!dashboardHeader" to="/campaigns"
                             :class="['nav-links', 'tab',{'active':campaignArea}]">
                    <li class="nav-li-item center"><span>Kampagnen</span></li>
                </router-link>

                <router-link v-if="!dashboardHeader" to="/templates/trackinglists"
                             :class="['nav-links', 'tab',{'active':templateArea}]">
                    <li class="nav-li-item center"><span>Vorlagen</span></li>
                </router-link>

                <router-link v-if="dashboardHeader" :to="'/campaigns/'+$route.params.id+'/dashboard'"
                             :class="['nav-links', 'tab',{'active':(route === 'showDashboard')}]">
                    <li class="nav-li-item center"><span>Dashboard</span></li>
                </router-link>

                <router-link v-if="dashboardHeader" :to="'/campaigns/'+$route.params.id+'/reporting'"
                             :class="['nav-links', 'tab',{'active':(route === 'showReporting')}]">
                    <li class="nav-li-item center"><span>Reporting</span></li>
                </router-link>

                <li v-if="!dashboardHeader" class="nav-li-item">
                    <UserDropdown :username="username" :usermail="usermail"></UserDropdown>
                </li>
            </ul>
        </nav>
        <ShareDialog :show="showShareDialog" v-if="showShareDialog" @close="showShareDialog = false"></ShareDialog>
    </div>

</template>

<script>
import AdaButton from "../buttons/AdaButton";
import UserDropdown from "./UserDropdown";
import ShareDialog from "../dialog/ShareDialog";

export default {
    name: "Header",
    components: {AdaButton, UserDropdown, ShareDialog},
    props: [
        'username',
        'usermail'
    ],
    data: function () {
        return {
            showShareDialog: false,
            saveTrackinglistLoader: false,
            saveCampaignLoader: false,
            savingDashboard: false,
            excelLoader: false,
            fn_trackinglistLoader: null,
            fn_campaignLoader: null,
            fn_dashboardLoader: null,
            fn_excelLoader: null,
        }
    },
    mounted() {
        this.fn_trackinglistLoader = (load) => {
            this.saveTrackinglistLoader = load;
        };
        this.fn_campaignLoader = (load) => {
            this.saveCampaignLoader = load;
        };
        this.fn_dashboardLoader = (load) => {
            this.savingDashboard = load;
        };
        this.fn_excelLoader = (load) => {
            this.excelLoader = load;
        };
        this.$root.$on('trackinglistLoader', this.fn_trackinglistLoader);
        this.$root.$on('campaignLoader', this.fn_campaignLoader);
        this.$root.$on('dashboardLoader', this.fn_dashboardLoader);
        this.$root.$on('excelLoader', this.fn_excelLoader);
    },
    beforeDestroy() {
        this.$root.$off('trackinglistLoader', this.fn_trackinglistLoader);
        this.$root.$off('campaignLoader', this.fn_campaignLoader);
        this.$root.$off('dashboardLoader', this.fn_dashboardLoader);
        this.$root.$off('dashboardLoader', this.fn_excelLoader);
    },
    computed: {
        createTemplate: function () {
            if (this.route === 'templatetrackinglists') {
                return '/templates/trackinglists/create';
            } else if (this.route === 'templatespaces') {
                return '/templates/spaces/create';
            } else if (this.route === 'templatemodules') {
                return '/templates/modules/create';
            }
            return this.$route.path;
        },
        impressumHeader: function () {
            return (this.route === 'impressum');
        },
        dashboardHeader: function () {
            return (this.route === 'showDashboard' ||
                this.route === 'editDashboard' ||
                this.route === 'showReporting');
        },
        trackinglistHeader: function () {
            return (this.route === 'trackinglist' ||
                this.route === 'createtrackinglisttemplate' ||
                this.route === 'edittrackinglisttemplate');
        },
        templateHeader: function () {
            return (this.route === 'templatespaces' ||
                this.route === 'templatemodules' ||
                this.route === 'templatetrackinglists');
        },
        spaceHeader: function () {
            return (this.route === 'createspacetemplate' ||
                this.route === 'editspacetemplate');
        },
        moduleHeader: function () {
            return (this.route === 'createmoduletemplate' ||
                this.route === 'editmoduletemplate');
        },
        route: function () {
            return this.$route.name
        },
        isDashboardEditable() {
            if ((/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                return false;
            } else if (typeof this.$route.query.key !== 'undefined') {
                return false;
            }
            return true;
        },
        isCustomerView() {
            return typeof this.$route.query.key !== 'undefined';
        },
        campaignArea() {
            return (this.route === 'trackinglist' || this.route.toLowerCase().indexOf('campaign') !== -1);
        },
        templateArea() {
            return this.route.toLowerCase().indexOf('template') !== -1;
        }
    },
    methods: {
        openShareDialog() {
            this.showShareDialog = true;
        },
        toggleNav: function () {
            this.$refs.mainNav.classList.toggle("active");
        },
        saveDashboard: function () {
            this.$root.$emit('saveDashboardHeader');
        },
        saveCampaign: function () {
            this.$root.$emit('saveCampaign');
        },
        saveTrackinglist: function () {
            if (this.route === 'trackinglist') {
                this.$root.$emit('saveTrackinglist', 'headerSaveButton');
            } else if (this.route === 'createtrackinglisttemplate') {
                this.$root.$emit('saveCreateTrackinglist');
            } else if (this.route === 'edittrackinglisttemplate') {
                this.$root.$emit('saveEditTrackinglist');
            }
        },
        saveSpaceTemplate: function () {
            this.$root.$emit('saveSpaceTemplate');
        },
        saveModuleTemplate: function () {
            this.$root.$emit('saveModuleTemplate');
        },
        updateCampaign: function () {
            this.$root.$emit('updateCampaign');
        },
        createInteraction() {
            this.$root.$emit('createInteractionTemplate')
        },
        exportTrackingList() {
            this.$root.$emit('exportTrackingList');
        }
    },
}


</script>

<style scoped lang="scss">
.nav-li-item > span {
    margin: auto;
    padding-top: 1em;
    padding-bottom: 1em;
    font-size: 16px;
}

.nav-li-item > a {
    margin: auto;
}

#rootElement {
    background-color: $headerBackground;
}

.navbar {
    font-size: 17px;
    background-color: $headerBackground;
    padding-bottom: 10px;
    transition: width 0.3s ease-in-out;
}

.main-nav {
    list-style-type: none;
    display: none;
    height: 100%;
    padding-left: 0px;
}

.nav-links,
.logo, .toolName {
    text-decoration: none;
    color: inherit;
    height: 100%;
}

.toolName {
    font-size: 1em;
    font-weight: bold;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
}

.toolNameWrapper {
    width: 6em;
    display: inline-block;
    padding-left: 2em;
    color: $darkGrey;
    text-decoration: none;
}

.main-nav li {
    text-align: center;
}

.logo {
    display: inline-block;
    font-size: 22px;
    margin-top: 10px;
    margin-left: 20px;
}

.navbar-toggle {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    font-size: 24px;
}

.active {
    display: block;
}

.logo > img {
    height: 30px;
}

::v-deep .createButton {
    padding: 9px 19px;
}

@media screen and (min-width: 1025px) {

    #js-menu > li {
        margin-right: 30px;
    }

    .marginLeft {
        margin-left: 20px;
    }

    .nav-content {
        width: 80%;
        margin: auto;
    }
    .navbar {
        justify-content: space-between;
        padding-bottom: 0;
        height: 70px;
        margin: auto;
        display: flex;
        align-items: center;
        width: 85%;
        max-width: 1400px;
    }

    .logo > img {
        height: 45px;
    }

    .main-nav {
        display: flex;
        margin-right: 30px;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }

    .logo {
        margin-top: 0;
    }

    .navbar-toggle {
        display: none;
    }
    .nav-links {
        margin: 0;
        padding-left: 20px;
        padding-right: 20px;
        color: #000;
    }

    .nav-links.tab.active, .nav-links.tab:hover {
        border-top: 3px solid $pink;
        color: $pink;
    }
}

@media screen and (min-width: 1225px) {
    .navbar {
        width: 85%;
    }
}

@media screen and (max-width: 1225px) {
    .navbar {
        width: 100%;
    }
}


</style>